var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "footer-hide": "",
      "width": "450px",
      "mask-closable": false
    },
    model: {
      value: _vm.showModal,
      callback: function ($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "unit_select"
  }, [_c('div', {
    staticClass: "card-login-text",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v($t("auou544", "单位选择"))])]), _c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "unit_box"
  }, [_c('Input', {
    staticStyle: {
      "width": "300px",
      "margin-bottom": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": $t("moo9h87", "请输入单位名称"),
      "search": ""
    },
    on: {
      "on-search": _vm.getListHotels,
      "on-clear": _vm.getListHotels
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _vm._l(_vm.units, function (item) {
    return _c('Tooltip', {
      key: item.unitId,
      attrs: {
        "max-width": "200",
        "placement": "top",
        "content": item.name || item.descript
      }
    }, [_c('Button', {
      staticClass: "unit-list",
      on: {
        "click": function ($event) {
          return _vm.checkUnit(item);
        }
      }
    }, [_vm._v(_vm._s(item.code) + " - " + _vm._s(item.name || item.descript))])], 1);
  })], 2)]), _c('OpenAppModal', {
    ref: "OpenAppModal"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };